import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { COLORS, FONT, settingsScrollContainerSx, settingsScrollInnerSx, settingsTabBarSx, SETTINGS_HORIZONTAL_PADDING } from "../shared/styles";

const TABS = [
  { key: "account-security", label: "Account Security" },
  { key: "active-sessions", label: "Active Sessions" },
  { key: "tag-management", label: "Tag Management" },
  { key: "canned-responses", label: "Canned Responses" },
  { key: "link-email", label: "Link Email" },
  { key: "notification-preferences", label: "Notification Preferences" },
];

const TABLE_TABS = new Set([
  "tag-management",
]);

const tabSx = {
  color: COLORS.textSecondary,
  fontFamily: FONT.family,
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "18px",
  textDecoration: "none",
  cursor: "pointer",
  pb: "16px",
  borderBottom: "1px solid transparent",
};

const tabActiveSx = {
  color: COLORS.textPrimary,
  fontWeight: 500,
  borderBottomColor: COLORS.primary,
};

function SettingsV2Layout() {
  const location = useLocation();
  const activeTabKey = location.pathname.split("/").pop() || "";
  const isTableTab = TABLE_TABS.has(activeTabKey);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0",
        minHeight: 0,
        maxHeight: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          ...settingsTabBarSx,
          px: SETTINGS_HORIZONTAL_PADDING,
          boxSizing: "border-box",
        }}
      >
        {TABS.map((tab) => (
          <Box
            key={tab.key}
            component={NavLink}
            to={tab.key}
            end={false}
            sx={{
              ...tabSx,
              "&.active": tabActiveSx,
            }}
          >
            {tab.label}
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          ...settingsScrollContainerSx,
          overflowY: isTableTab ? "hidden" : "auto",
          ...(isTableTab && {
            display: "flex",
            flexDirection: "column",
            "& > *": {
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
            },
          }),
        }}
      >
        <Box sx={settingsScrollInnerSx}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default SettingsV2Layout;
